import purify from '../../node_modules/dompurify/dist/purify.es.js';

const ALLOWED_TAGS = [
  "a",
  "abbr",
  "b",
  "blockquote",
  "br",
  "code",
  "em",
  "i",
  "img",
  "li",
  "ol",
  "p",
  "pre",
  "strong",
  "ul",
  "h1",
  "h2",
  "h3",
  "h4",
  "h5",
  "h6",
  "table",
  "thead",
  "tbody",
  "tr",
  "th",
  "td",
  "div",
  "span",
  "hr"
];
const ALLOWED_ATTR = [
  "href",
  "title",
  "alt",
  "src",
  "target",
  "rel",
  "aria-*",
  "colspan",
  "rowspan"
];
const HTMLPreviewPurifyConfig = {
  // Specify allowed tags
  ALLOWED_TAGS,
  // Specify allowed attributes
  ALLOWED_ATTR,
  // Enforce URI schemes for attributes like href and src
  ALLOWED_URI_REGEXP: /^(?:(?:https?|mailto|tel):|[^a-z]|[a-z+.\-]+(?:[^a-z+.\-:]|$))/i,
  // Disable the use of CSS styles
  FORBID_ATTR: [
    "style",
    "class"
  ],
  // Disable any inline event handlers
  FORBID_TAGS: [
    "style",
    "script",
    "iframe",
    "object",
    "embed",
    "button",
    "input",
    "textarea",
    "select",
    "form"
  ],
  // Prevent the use of data URLs in src attributes
  ALLOW_DATA_ATTR: false,
  // Ensure that comments are removed
  KEEP_CONTENT: false,
  // Disallow CSS expressions and other malicious content in attributes
  SANITIZE_DOM: true,
  // Use the 'basic' sanitization to keep it simple and efficient
  // You can adjust according to your needs
  USE_PROFILES: {
    html: true,
    svg: true,
    svgFilters: true
  }
};
const purifyHTMLPreview = (html) => {
  return purify.sanitize(html, HTMLPreviewPurifyConfig).toString();
};

export { purifyHTMLPreview };
//# sourceMappingURL=html.utils.js.map
